import ReportTypeScreen from "../../Components/Reports/ReportTypeScreen";

function ReportedPicturePostComments() {
  return <ReportTypeScreen reportType="picture_post_comment" />;
}

export default ReportedPicturePostComments;
